<template>
    <div class="container panel">
        <section class="section">
            <h1 class="title">{{ $t('title.jobs') }}</h1>

            <div class="buttons has-addons">
                <button class="button" @click="edit" :disabled="!local.selected">
                    <b-icon icon="pencil-outline" size="is-small"></b-icon>
                    <span>{{ $t('button.edit') }}</span>
                </button>
            </div>

            <b-table
                hoverable
                paginated
                striped
                :selected.sync="local.selected"
                :data="local.rows"
                :loading="local.loading"
                backend-pagination
                :total="local.total"
                :per-page="local.perPage"
                :current-page="local.page"
                @page-change="onPageChange"
                @click="onRowClick"
            >
                <b-table-column v-slot="props" field="description" :label="$t('field.description').toString()">
                    {{ props.row.description }}
                </b-table-column>
                <b-table-column v-slot="props" field="started" :label="$t('field.started').toString()">
                    {{ dateTimeToString(props.row.started) }}
                </b-table-column>
                <b-table-column v-slot="props" field="ended" :label="$t('field.ended').toString()">
                    {{ dateTimeToString(props.row.ended) }}
                </b-table-column>
                <b-table-column v-slot="props" field="success" :label="$t('field.success').toString()">
                    {{ props.row.success }}
                </b-table-column>
                <b-table-column
                    v-slot="props"
                    field="correctiveActionRequired"
                    :label="$t('field.correctiveActionRequired').toString()"
                >
                    {{ props.row.correctiveActionRequired }}
                </b-table-column>
                <b-table-column
                    v-slot="props"
                    field="correctiveActionCompleted"
                    :label="$t('field.correctiveActionCompleted').toString()"
                >
                    {{ props.row.correctiveActionCompleted }}
                </b-table-column>
            </b-table>
        </section>
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

import { sharedState } from '../../../state';

import { deleteResource, getResourcePaging, getResources } from '../../../client/resource';
import { Job } from '../../../../../common/framework/model/Job';
import { dateToUiDateTimeString } from '../../../../../common/framework/util/convert';
import {PageSize} from "../../../../../common/application/model/enums/PageSize";

@Component
export default class Jobs extends Vue {
    readonly resourceType = 'job';

    shared = sharedState;
    local = {
        rows: new Array<Job>(),
        total: 0,
        loading: false,
        page: 1,
        perPage: PageSize.S,
        selected: undefined as Job | undefined,
    };

    async mounted() {
        await this.loadAsyncData();
    }

    async onPageChange(page: number) {
        this.local.page = page;
        await this.loadAsyncData();
    }

    add() {
        this.$router.push('/job/add');
    }

    edit() {
        if (this.local.selected) {
            this.$router.push('/job/' + this.local.selected.id + '/edit');
        }
    }

    confirmDelete() {
        this.$buefy.dialog.confirm({
            title: this.$t('title.confirmDelete').toString(),
            message: this.$t('message.confirmDelete').toString(),
            cancelText: this.$t('button.cancel').toString(),
            confirmText: this.$t('button.ok').toString(),
            type: 'is-success',
            onConfirm: async () => {
                if (this.local.selected) {
                    await deleteResource(this.resourceType, this.local.selected.id);
                    await this.loadAsyncData();
                }
            },
        });
    }

    async loadAsyncData() {
        this.local.loading = true;
        this.local.total = (await getResourcePaging(this.resourceType)).pageCount * this.local.perPage;
        this.local.rows = [];
        const rows = (await getResources(this.resourceType, this.local.page - 1)) as Array<Job>;
        rows.forEach((row) => {
            this.local.rows.push(row);
        });
        this.local.loading = false;
        if (this.local && this.local.rows.indexOf(this.local.selected!!) == -1) {
            this.local.selected = undefined;
        }
    }

    dateTimeToString(timestamp: Date) {
        return dateToUiDateTimeString(timestamp);
    }

    onRowClick(row: Job): void {
        if (this.local.selected && row.id === this.local.selected.id) {
            this.local.selected = undefined;
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
